



























// https://vuejs.org/v2/examples/modal.html
import { Vue, Component, Prop } from 'vue-property-decorator';

const ESC_KEY_CODE = 27;

@Component
export default class ModalComponent extends Vue {
    @Prop()
    show?: boolean;

    @Prop({ 'default': false })
    locked?: boolean;

    mounted() {
        document.addEventListener('keydown', (e) => {
            if (this.show && e.keyCode === ESC_KEY_CODE) {
                this.close();
            }
        });
    }

    close() {
        this.$emit('close');
    }
}
